<template>
  <div class="gray-back">
    <div class="mine-box-title">{{ $T('我的订单') }}</div>
    <div class="mine-content">
      <el-tabs v-model="active" @tab-click="onStatusChange">
        <el-tab-pane :label="$T('全部')" name="0" />
        <el-tab-pane :label="$T('待付款')" name="1" />
        <el-tab-pane :label="$T('待发货')" name="3" />
        <el-tab-pane :label="$T('待收货')" name="4" />
      </el-tabs>

      <div v-if="loading" class="bc-order-empty">{{ $T('观众中心加载中') }}</div>
      <div v-else-if="!list.length" class="bc-order-empty">{{ $T('暂无订单') }}</div>

      <el-table v-else :data="list" :show-header="false">
        <el-table-column min-width="220">
          <template slot-scope="scope">
            <div class="bc-order-row">
              <img
                class="bc-order-pic"
                :src="firstItemPic(scope.row)"
                alt=""
              />
              <div>
                <div class="bc-order-title">{{ scope.row.title }}</div>
                <div class="gray-light">
                  {{ $T('订单号') }} {{ scope.row.code || scope.row.id }}
                </div>
                <div class="gray-light goods-num">
                  {{ itemCountText(scope.row) }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="120">
          <template slot-scope="scope">
            <div class="table-goods-price">
              {{ money(scope.row.pay_price) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column width="140">
          <template slot-scope="scope">
            <div>{{ formatTime(scope.row) }}</div>
          </template>
        </el-table-column>
        <el-table-column width="120">
          <template slot-scope="scope">
            <el-tag size="small" :type="statusTagType(scope.row)">
              {{ statusName(scope.row) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="right" min-width="200">
          <template slot-scope="scope">
            <el-button
              v-for="(btn, bi) in actionButtons(scope.row)"
              :key="'b' + bi"
              size="medium"
              :type="btn.class === 'primary' ? 'primary' : 'default'"
              @click="onAction(scope.row, btn)"
            >
              {{ btnLabel(btn) }}
            </el-button>
            <el-button size="medium" type="primary" @click="goDetail(scope.row)">
              {{ $T('订单详情') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="table-pagination" v-if="total > 0">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <SpectatorOfflinePayDialog
      :show="payDialogShow"
      :ids="payOrderIds"
      :pay-price="payOrderPrice"
      @onPaid="onOfflinePaid"
      @onClose="payDialogShow = false"
    />
  </div>
</template>

<script>
import { Toast } from 'vant';
import SpectatorOfflinePayDialog from '@/page/mainindex/SpectatorOfflinePayDialog.vue';
import { spectatorMoney } from '@/utils/spectatorMoney';

export default {
  name: 'SpectatorOrderList',
  components: { SpectatorOfflinePayDialog },
  data() {
    return {
      active: '0',
      list: [],
      loading: false,
      page: 1,
      pageSize: 10,
      total: 0,
      payDialogShow: false,
      payOrderIds: [],
      payOrderPrice: '',
    };
  },
  mounted() {
    document.title = this.$T('我的订单');
    this.fetch();
  },
  methods: {
    money: spectatorMoney,
    firstItemPic(row) {
      const items = row.items || [];
      if (items.length && items[0].pic_url) {
        return items[0].pic_url;
      }
      return '';
    },
    itemCountText(row) {
      const items = row.items || [];
      const n = items.reduce((sum, g) => sum + (Number(g.count) || 0), 0);
      return this.$T('共x件').replace('{n}', String(n || items.length || 0));
    },
    formatTime(row) {
      if (row.create_time_str) return row.create_time_str;
      if (row.create_time) {
        const d = new Date(row.create_time * 1000);
        const pad = (x) => (x < 10 ? '0' + x : '' + x);
        return (
          d.getFullYear() +
          '-' +
          pad(d.getMonth() + 1) +
          '-' +
          pad(d.getDate()) +
          ' ' +
          pad(d.getHours()) +
          ':' +
          pad(d.getMinutes())
        );
      }
      return '';
    },
    statusName(row) {
      const sb = row.status_buttons || {};
      return sb.name || this.$T('处理中');
    },
    statusTagType(row) {
      const cls = (row.status_buttons && row.status_buttons.class) || '';
      if (cls === 'warning') return 'warning';
      if (cls === 'success') return 'success';
      if (cls === 'danger') return 'danger';
      return 'info';
    },
    actionButtons(row) {
      const buttons = (row.status_buttons && row.status_buttons.buttons) || [];
      return buttons.filter((b) => b.type === 'pay' || b.type === 'offline');
    },
    btnLabel(btn) {
      if (btn.type === 'pay') return this.$T('去支付');
      if (btn.type === 'offline') {
        return btn.name === '更新支付凭证'
          ? this.$T('更新支付凭证')
          : this.$T('上传支付凭证');
      }
      return btn.name;
    },
    onStatusChange() {
      this.page = 1;
      this.fetch();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.fetch();
    },
    fetch() {
      const that = this;
      that.loading = true;
      that.$api.get(
        '/api/order/orderList',
        {
          status: that.active,
          p: that.page,
          step: that.pageSize,
        },
        (res) => {
          const data = res.data || {};
          that.list = data.list || [];
          that.total = data.total || 0;
          that.page = data.currentpage || that.page;
          that.loading = false;
        },
        (res) => {
          that.list = [];
          that.loading = false;
          if (res && (res.code == 401 || res.code == 402)) {
            Toast(that.$T('观众中心请先登录'));
          }
        }
      );
    },
    goDetail(row) {
      this.$router.push({
        path: '/spectator-orders/detail',
        query: { id: row.id },
      });
    },
    onAction(row, btn) {
      if (btn.type === 'offline') {
        this.$router.push({
          path: '/spectator/offline-voucher',
          query: { ids: String(row.id), price: row.pay_price },
        });
        return;
      }
      if (btn.type === 'pay') {
        this.payOrderIds = [row.id];
        this.payOrderPrice = row.pay_price;
        this.payDialogShow = true;
      }
    },
    onOfflinePaid(ids) {
      this.payDialogShow = false;
      const idList = ids && ids.length ? ids : this.payOrderIds;
      this.$router.push({
        path: '/spectator/offline-voucher',
        query: {
          ids: (idList || []).join(','),
          price: this.payOrderPrice,
        },
      });
    },
  },
};
</script>

<style scoped>
.bc-order-empty {
  text-align: center;
  color: #999;
  padding: 48px 0;
  font-size: 14px;
}
.bc-order-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.bc-order-pic {
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 6px;
  background: #f3f4f6;
  flex-shrink: 0;
}
.bc-order-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e2842;
  margin-bottom: 4px;
  line-height: 1.4;
}
.gray-light {
  font-size: 12px;
  color: #999;
  line-height: 1.5;
}
.goods-num {
  margin-top: 2px;
}
.table-goods-price {
  color: #c2410c;
  font-weight: 600;
  font-size: 15px;
}
.table-pagination {
  margin-top: 16px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// SpectatorOrderList.vue?55abfced